import { MediaMatcher } from '@angular/cdk/layout';
import {
	ChangeDetectorRef,
	Component,
	OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NgFor, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { pageTransitions } from '../animations/page-transitions';
import { DatacenterType, UserDatacenterView } from '../models/datacenter-aggrid-view';
import { User } from '../models/user';
import { UserService } from '../services/user.service';
import { fromMediaQueryListEvent } from '../utils/media-query';
import { BackButtonComponent } from '../components/back-button/back-button.component';

@Component({
	selector: 'copo-all-datacenter-access',
	templateUrl: './all-datacenter-access.component.html',
	styleUrl: './all-datacenter-access.component.css',
	animations: pageTransitions,

	imports: [BackButtonComponent, TranslateModule, NgIf, NgFor, MatButtonModule, MatIconModule, RouterLink]
})

export class AllDatacenterAccessComponent implements OnDestroy {
	user: User;
	mediaQuery: MediaQueryList;
	mediaQuerySubscription: Subscription;
	favoriteViewsByType: Partial<Record<DatacenterType, UserDatacenterView[]>> = {};
	constructor(
		private readonly userService: UserService,
		private readonly media: MediaMatcher,
		private readonly changeDetectorRef: ChangeDetectorRef
	) {
		this.user = this.userService.user;
		this.initializeFavoriteViews();
		this.mediaQuery = this.media.matchMedia('screen and (width <= 768px)');
		this.mediaQuerySubscription =
			fromMediaQueryListEvent(this.mediaQuery).subscribe(() => {
				this.changeDetectorRef.markForCheck();
			});
	}

	getFavoriteViews(type: DatacenterType) {
		return this.favoriteViewsByType[type] ?? [];
	}

	trackByViewId(_index: number, view: UserDatacenterView) {
		return view.id;
	}

	ngOnDestroy() {
		this.mediaQuerySubscription.unsubscribe();
	}

	private initializeFavoriteViews() {
		const { datacenterViews } = this.user;
		this.favoriteViewsByType = datacenterViews
			.filter(view => view.isFavorite)
			.reduce<Partial<Record<DatacenterType, UserDatacenterView[]>>>((acc, view) => {
				const current = acc[view.type] ?? [];
				acc[view.type] = [...current, view];
				return acc;
			}, {});

		for (const type of <DatacenterType[]> Object.keys(this.favoriteViewsByType)) {
			this.favoriteViewsByType[type]?.sort((a, b) => a.name.localeCompare(b.name));
		}
	}
}
